module.exports = __webpack_public_path__ + "media/application/images/ui/icon-close-lightgrey-a649964f1271d8268dc44cf80c078b44.png";